import useGetApi from 'src/api/useGetApi';
import GroupDetailsDTO from 'src/types/user-management/GroupDetailsDTO';

type ApiResponse = {
  group: GroupDetailsDTO;
};

const useOrganizationGroupDetails = (groupId: string) => {
  return useGetApi<ApiResponse>({
    endpoint: `organization/groups/${groupId}`,
    queryKey: ['organization/groups', groupId],
    options: {
      enabled: !!groupId,
    },
  });
};

export default useOrganizationGroupDetails;
